export default class AccountPasswordController {
	/* @ngInject */
	/**
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('~/scripts/providers/models/notification').NotificationService} Notification
	 */
	constructor($translate, Notification) {
		this.$translate = $translate;
		this.Notification = Notification;
	}

	/**
	 * Notify the user about the password change
	 */
	confirmPasswordChange() {
		this.Notification.info({
			title:   this.$translate.instant('common.info'),
			message: this.$translate.instant('user.password-updated'),
		});
	}
}
